'use client'

import { Play } from 'lucide-react'

import { useTriggerAutomation } from '~/components/automations/useAutomationActions'
import { Button } from '~/components/component-library'
import { Automation } from '~/types/automations'

export const TriggerAutomationButton = ({
  automation,
  isDisabled,
}: {
  automation?: Automation
  isDisabled?: boolean
}) => {
  const { trigger, isTriggering } = useTriggerAutomation(automation?.id)

  return (
    <Button
      variant="secondary"
      prefix={<Play className="w-4" />}
      onClick={trigger}
      isLoading={isTriggering}
      isDisabled={isDisabled || !automation?.isActive}
      disabledReason={
        automation && !automation.isActive
          ? 'Automation is not active'
          : undefined
      }
    >
      Trigger
    </Button>
  )
}
